<!-- Keeps the end of the page (footer) clear of the fixed strip -->
<div class="preview-banner-spacer" aria-hidden="true"></div>
<div class="preview-banner d-flex align-items-center justify-content-center gap-3 px-4" role="status">
    <span class="preview-badge d-inline-flex align-items-center gap-1 flex-shrink-0 fw-bold">
        <ng-icon name="heroEye" size="14" />
        Preview
    </span>
    <span class="text-truncate">This post may not be published yet. Only people with this link can see it.</span>
</div>
